export default __webpack_public_path__ + "static/media/coin.83f34172.png";